import React from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_USER_CONDITION_OPTION_ID, formatConditionValue } from '../../../../../utils/helpers/conditions'
import { useFormState } from '../../../../../packages/kiti/components/form/form/FormHandler'
import ChecklistSelect from '../../../../../containers/checklists/select/ChecklistSelect'
import EditableSentence from '../EditableSentence'
import FormSelect from '../../../../../containers/forms/select/FormSelect'
import GroupSelect from '../../../../../containers/groups/select/GroupSelect'
import NonComplianceEventTypeSelect from '../../../../../containers/nonComplianceEvents/select/NonComplianceEventTypeSelect'
import PlaceLevelSelect from '../../../../../containers/placeLevels/select/PlaceLevelSelect'
import PlaceSelect from '../../../../../containers/places/select/PlaceSelect'
import QuestionSelect from '../../../../../containers/questions/select/QuestionSelect'
import ServiceOrderStatusSelect from '../../../../../containers/statuses/select/ServiceOrderStatusSelect'
import TagSelect from '../../../../../containers/tags/select/TagSelect'
import Text from '../../../../../packages/kiti/components/presentation/Text'
import UserSelect from '../../../../../containers/users/select/UserSelect'
import PlaceTypeSelect from '../../../../../containers/places/select/PlaceTypeSelect'
import { ACTIVITY_TAG_TYPE } from '../../../../tags/_constants'

const getSelect = field => {
  field = field || ''
  if (field.endsWith('place_id')) return PlaceSelect
  if (field.endsWith('user_id')) return UserSelect
  if (field.endsWith('checklist_id')) return ChecklistSelect
  if (field.endsWith('question_id')) return QuestionSelect
  if (field.endsWith('status_id')) return ServiceOrderStatusSelect
  if (field.endsWith('group_id')) return GroupSelect
  if (field.endsWith('non_compliance_event.type')) return NonComplianceEventTypeSelect
  if (field.endsWith('form_id')) return FormSelect
  if (field.endsWith('tag_id') || field.endsWith('tag_ids')) return TagSelect
  if (field.endsWith('place_level_ids')) return PlaceLevelSelect
  if (field.endsWith('place_type_id')) return PlaceTypeSelect
  return false
}

// A condição de tag da pergunta de checklist (`tag_ids`, ver `non_compliance.question.tag_ids`) não
// passa `type`, então continua listando tags de qualquer `type`. A condição de tag de atividade
// (`tag_id`) é nova e precisa do filtro explícito para não misturar as duas.
const getSelectProps = field => (field?.endsWith('tag_id') ? { type: ACTIVITY_TAG_TYPE, allowCreate: false } : {})

const ValueSentence = ({ condition, index }) => {
  const { t } = useTranslation('common')
  const { handleChangeIn } = useFormState()

  const Select = getSelect(condition.field)
  if (!Select)
    return (
      <Text size="h2" bold>
        _______
      </Text>
    )

  const multiple = ['any', 'in', 'all'].includes(condition.operator)
  const isUserEqEmpty =
    (condition.field || '').endsWith('user_id') &&
    (condition.operator || 'eq') === 'eq'

  const mergedOptions = isUserEqEmpty
    ? [{ id: EMPTY_USER_CONDITION_OPTION_ID, name: t('conditions.emptyUser') }]
    : undefined

  const setValue = handleChangeIn(['conditions', index, 'value'])
  const handleValueChange = value => {
    if (value?.id === EMPTY_USER_CONDITION_OPTION_ID) {
      setValue(null)
      return
    }
    setValue(value)
  }

  return (
    <EditableSentence
      label={formatConditionValue(condition)}
      path={['conditions', index, 'value']}
      onChange={handleValueChange}
      Input={Select}
      multiple={multiple}
      disableCloseOnChange={multiple}
      disableCloseOnBlur={multiple}
      returnObject={condition.field.endsWith('place.place_type_id')}
      mergedOptions={mergedOptions}
      {...getSelectProps(condition.field)}
    />
  )
}

export default ValueSentence
